module.exports = __webpack_public_path__ + "static/img/icon_volume.1c2dd53d.svg";